/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sysque-location-options-line',
  templateUrl: './sysque-location-options-line.component.html',
  styleUrls: ['./sysque-location-options-line.component.scss'],
  standalone: false
})
export class SysqueLocationOptionsLineComponent {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() locationPath: string;
  @Output() getPath = new EventEmitter<string>();
  @Output() valueChanged: EventEmitter<string> = new EventEmitter<string>();

  public onClick(): void {
    this.getPath.emit();
  }

  public onValueChanged($event: string): void {
    this.valueChanged.emit($event);
  }
}
